/* eslint react-hooks/exhaustive-deps: 0 */

import { useEffect } from "react";

const useMount = (func) => useEffect(func, []);

export default useMount;
